import React from "react";
import { Loading } from "@therms/atalaya";
import { jsx } from "react/jsx-runtime";
//#region src/modules/Locations/shared/LocationDetailsMap/index.tsx
var LocationDetailsMapImpl = React.lazy(() => import("./LocationDetailsMapImpl.js").then((m) => ({ default: m.LocationDetailsMap })));
function LocationDetailsMap(props) {
	return /* @__PURE__ */ jsx(React.Suspense, {
		fallback: /* @__PURE__ */ jsx(Loading, { overlay: true }),
		children: /* @__PURE__ */ jsx(LocationDetailsMapImpl, { ...props })
	});
}
//#endregion
export { LocationDetailsMap };

//# sourceMappingURL=index.js.map